export default __webpack_public_path__ + "4785b1a4f6049b2a1732a38cb4740674.png";